import { render, staticRenderFns } from "./CardUser.vue?vue&type=template&id=907df300&scoped=true&"
import script from "./CardUser.vue?vue&type=script&lang=ts&"
export * from "./CardUser.vue?vue&type=script&lang=ts&"
import style0 from "./CardUser.vue?vue&type=style&index=0&id=907df300&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907df300",
  null
  
)

export default component.exports